// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/time_tracking.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type {
  GenEnum,
  GenFile,
  GenMessage,
  GenService,
} from '@bufbuild/protobuf/codegenv2';
import {
  enumDesc,
  fileDesc,
  messageDesc,
  serviceDesc,
} from '@bufbuild/protobuf/codegenv2';
import type { Timestamp, TimestampJson } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import { file_buf_validate_validate } from '../../buf/validate/validate_pb';
import type {
  DenormalizedClient,
  DenormalizedClientJson,
  DenormalizedProject,
  DenormalizedProjectJob,
  DenormalizedProjectJobJson,
  DenormalizedProjectJson,
  DenormalizedSurveyTask,
  DenormalizedSurveyTaskJson,
  DenormalizedUser,
  DenormalizedUserJson,
} from './denormalized_pb';
import { file_proto_v1_denormalized } from './denormalized_pb';
import { file_proto_v1_extension_enum } from './extension_enum_pb';
import type {
  AuditUpdater,
  AuditUpdaterJson,
  DateRange,
  DateRangeJson,
  Pagination,
  PaginationJson,
  ProjectJobType,
  ProjectJobTypeJson,
  SortDirection,
  SortDirectionJson,
} from './type_common_pb';
import { file_proto_v1_type_common } from './type_common_pb';

/**
 * Describes the file proto/v1/time_tracking.proto.
 */
export const file_proto_v1_time_tracking: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_buf_validate_validate,
      file_google_protobuf_timestamp,
      file_proto_v1_denormalized,
      file_proto_v1_extension_enum,
      file_proto_v1_type_common,
    ],
  );

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingJob
 */
export type TimeTrackingJob = Message<'vmspdb.api.proto.v1.TimeTrackingJob'> & {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 2;
   */
  type: ProjectJobType;
};

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingJob
 */
export type TimeTrackingJobJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 2;
   */
  type?: ProjectJobTypeJson;
};

export type TimeTrackingJobValid = TimeTrackingJob;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingJob.
 * Use `create(TimeTrackingJobSchema)` to create a new message.
 */
export const TimeTrackingJobSchema: GenMessage<
  TimeTrackingJob,
  { jsonType: TimeTrackingJobJson; validType: TimeTrackingJobValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 0);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingCustomType
 */
export type TimeTrackingCustomType =
  Message<'vmspdb.api.proto.v1.TimeTrackingCustomType'> & {
    /**
     * @generated from field: string text = 1;
     */
    text: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingCustomType
 */
export type TimeTrackingCustomTypeJson = {
  /**
   * @generated from field: string text = 1;
   */
  text?: string;
};

export type TimeTrackingCustomTypeValid = TimeTrackingCustomType;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingCustomType.
 * Use `create(TimeTrackingCustomTypeSchema)` to create a new message.
 */
export const TimeTrackingCustomTypeSchema: GenMessage<
  TimeTrackingCustomType,
  {
    jsonType: TimeTrackingCustomTypeJson;
    validType: TimeTrackingCustomTypeValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 1);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingTaskType
 */
export type TimeTrackingTaskType =
  Message<'vmspdb.api.proto.v1.TimeTrackingTaskType'> & {
    /**
     *  oneof type {
     *
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingDefaultType default = 2;
     */
    default: TimeTrackingDefaultType;

    /**
     *  }
     *
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingCustomType custom = 3;
     */
    custom?: TimeTrackingCustomType;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingTaskType
 */
export type TimeTrackingTaskTypeJson = {
  /**
   *  oneof type {
   *
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingDefaultType default = 2;
   */
  default?: TimeTrackingDefaultTypeJson;

  /**
   *  }
   *
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingCustomType custom = 3;
   */
  custom?: TimeTrackingCustomTypeJson;
};

export type TimeTrackingTaskTypeValid = TimeTrackingTaskType;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingTaskType.
 * Use `create(TimeTrackingTaskTypeSchema)` to create a new message.
 */
export const TimeTrackingTaskTypeSchema: GenMessage<
  TimeTrackingTaskType,
  { jsonType: TimeTrackingTaskTypeJson; validType: TimeTrackingTaskTypeValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 2);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingFlags
 */
export type TimeTrackingFlags =
  Message<'vmspdb.api.proto.v1.TimeTrackingFlags'> & {
    /**
     * @generated from field: bool employee_paid = 1;
     */
    employeePaid: boolean;

    /**
     * @generated from field: bool invoiced = 2;
     */
    invoiced: boolean;

    /**
     * @generated from field: bool non_project = 3;
     */
    nonProject: boolean;

    /**
     * @generated from field: bool billed = 4;
     */
    billed: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingFlags
 */
export type TimeTrackingFlagsJson = {
  /**
   * @generated from field: bool employee_paid = 1;
   */
  employeePaid?: boolean;

  /**
   * @generated from field: bool invoiced = 2;
   */
  invoiced?: boolean;

  /**
   * @generated from field: bool non_project = 3;
   */
  nonProject?: boolean;

  /**
   * @generated from field: bool billed = 4;
   */
  billed?: boolean;
};

export type TimeTrackingFlagsValid = TimeTrackingFlags;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingFlags.
 * Use `create(TimeTrackingFlagsSchema)` to create a new message.
 */
export const TimeTrackingFlagsSchema: GenMessage<
  TimeTrackingFlags,
  { jsonType: TimeTrackingFlagsJson; validType: TimeTrackingFlagsValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 3);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingBilling
 */
export type TimeTrackingBilling =
  Message<'vmspdb.api.proto.v1.TimeTrackingBilling'> & {
    /**
     * @generated from field: bool billed = 1;
     */
    billed: boolean;

    /**
     * @generated from field: string billed_to_client_uuid = 2;
     */
    billedToClientUuid: string;

    /**
     * @generated from field: string invoice_description = 3;
     */
    invoiceDescription: string;

    /**
     * @generated from field: double billed_hours = 4;
     */
    billedHours: number;

    /**
     * @generated from field: uint32 billed_seconds = 5;
     */
    billedSeconds: number;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingBilling
 */
export type TimeTrackingBillingJson = {
  /**
   * @generated from field: bool billed = 1;
   */
  billed?: boolean;

  /**
   * @generated from field: string billed_to_client_uuid = 2;
   */
  billedToClientUuid?: string;

  /**
   * @generated from field: string invoice_description = 3;
   */
  invoiceDescription?: string;

  /**
   * @generated from field: double billed_hours = 4;
   */
  billedHours?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: uint32 billed_seconds = 5;
   */
  billedSeconds?: number;
};

export type TimeTrackingBillingValid = TimeTrackingBilling;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingBilling.
 * Use `create(TimeTrackingBillingSchema)` to create a new message.
 */
export const TimeTrackingBillingSchema: GenMessage<
  TimeTrackingBilling,
  { jsonType: TimeTrackingBillingJson; validType: TimeTrackingBillingValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 4);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingEmployeeLineItem
 */
export type TimeTrackingEmployeeLineItem =
  Message<'vmspdb.api.proto.v1.TimeTrackingEmployeeLineItem'> & {
    /**
     * @generated from field: string employee_uuid = 2;
     */
    employeeUuid: string;

    /**
     * @generated from field: double total_hours = 3;
     */
    totalHours: number;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingEmployeeLineItem
 */
export type TimeTrackingEmployeeLineItemJson = {
  /**
   * @generated from field: string employee_uuid = 2;
   */
  employeeUuid?: string;

  /**
   * @generated from field: double total_hours = 3;
   */
  totalHours?: number | 'NaN' | 'Infinity' | '-Infinity';
};

export type TimeTrackingEmployeeLineItemValid = TimeTrackingEmployeeLineItem;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingEmployeeLineItem.
 * Use `create(TimeTrackingEmployeeLineItemSchema)` to create a new message.
 */
export const TimeTrackingEmployeeLineItemSchema: GenMessage<
  TimeTrackingEmployeeLineItem,
  {
    jsonType: TimeTrackingEmployeeLineItemJson;
    validType: TimeTrackingEmployeeLineItemValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 5);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceDenormalized
 */
export type TimeTrackingServiceDenormalized =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceDenormalized'> & {
    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedProject project = 1;
     */
    project?: DenormalizedProject;

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedProjectJob project_job = 2;
     */
    projectJob?: DenormalizedProjectJob;

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedUser employee = 3;
     */
    employee?: DenormalizedUser;

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedSurveyTask survey_task = 4;
     */
    surveyTask?: DenormalizedSurveyTask;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedClient project_clients = 5;
     */
    projectClients: DenormalizedClient[];

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedClient survey_task_requestor_client = 6;
     */
    surveyTaskRequestorClient?: DenormalizedClient;

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedClient billing_client = 7;
     */
    billingClient?: DenormalizedClient;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceDenormalized
 */
export type TimeTrackingServiceDenormalizedJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedProject project = 1;
   */
  project?: DenormalizedProjectJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedProjectJob project_job = 2;
   */
  projectJob?: DenormalizedProjectJobJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedUser employee = 3;
   */
  employee?: DenormalizedUserJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedSurveyTask survey_task = 4;
   */
  surveyTask?: DenormalizedSurveyTaskJson;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedClient project_clients = 5;
   */
  projectClients?: DenormalizedClientJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedClient survey_task_requestor_client = 6;
   */
  surveyTaskRequestorClient?: DenormalizedClientJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedClient billing_client = 7;
   */
  billingClient?: DenormalizedClientJson;
};

export type TimeTrackingServiceDenormalizedValid =
  TimeTrackingServiceDenormalized;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceDenormalized.
 * Use `create(TimeTrackingServiceDenormalizedSchema)` to create a new message.
 */
export const TimeTrackingServiceDenormalizedSchema: GenMessage<
  TimeTrackingServiceDenormalized,
  {
    jsonType: TimeTrackingServiceDenormalizedJson;
    validType: TimeTrackingServiceDenormalizedValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 6);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceCreateRequest
 */
export type TimeTrackingServiceCreateRequest =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceCreateRequest'> & {
    /**
     * @generated from field: optional string project_uuid = 2;
     */
    projectUuid?: string;

    /**
     * @generated from field: optional string project_job_uuid = 3;
     */
    projectJobUuid?: string;

    /**
     * @generated from field: double total_hours = 4;
     */
    totalHours: number;

    /**
     * @generated from field: google.protobuf.Timestamp date = 5;
     */
    date?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp start_time = 6;
     */
    startTime?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp end_time = 7;
     */
    endTime?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingTaskType task = 8;
     */
    task?: TimeTrackingTaskType;

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: string employee_uuid = 10;
     */
    employeeUuid: string;

    /**
     * @generated from field: uint32 total_seconds = 11 [deprecated = true];
     * @deprecated
     */
    totalSeconds: number;

    /**
     * @generated from field: bool in_progress = 12;
     */
    inProgress: boolean;

    /**
     * @generated from field: string project_survey_task_uuid = 13;
     */
    projectSurveyTaskUuid: string;

    /**
     * @generated from field: bool crew_leader = 14;
     */
    crewLeader: boolean;

    /**
     * @generated from field: map<string, string> attributes = 15;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingType type = 16;
     */
    type: TimeTrackingType;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingFlags flags = 17;
     */
    flags?: TimeTrackingFlags;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingBilling billing = 18;
     */
    billing?: TimeTrackingBilling;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceCreateRequest
 */
export type TimeTrackingServiceCreateRequestJson = {
  /**
   * @generated from field: optional string project_uuid = 2;
   */
  projectUuid?: string;

  /**
   * @generated from field: optional string project_job_uuid = 3;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: double total_hours = 4;
   */
  totalHours?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: google.protobuf.Timestamp date = 5;
   */
  date?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 6;
   */
  startTime?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 7;
   */
  endTime?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingTaskType task = 8;
   */
  task?: TimeTrackingTaskTypeJson;

  /**
   * @generated from field: string notes = 9;
   */
  notes?: string;

  /**
   * @generated from field: string employee_uuid = 10;
   */
  employeeUuid?: string;

  /**
   * @generated from field: uint32 total_seconds = 11 [deprecated = true];
   * @deprecated
   */
  totalSeconds?: number;

  /**
   * @generated from field: bool in_progress = 12;
   */
  inProgress?: boolean;

  /**
   * @generated from field: string project_survey_task_uuid = 13;
   */
  projectSurveyTaskUuid?: string;

  /**
   * @generated from field: bool crew_leader = 14;
   */
  crewLeader?: boolean;

  /**
   * @generated from field: map<string, string> attributes = 15;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingType type = 16;
   */
  type?: TimeTrackingTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingFlags flags = 17;
   */
  flags?: TimeTrackingFlagsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingBilling billing = 18;
   */
  billing?: TimeTrackingBillingJson;
};

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceCreateRequest
 */
export type TimeTrackingServiceCreateRequestValid =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceCreateRequest'> & {
    /**
     * @generated from field: optional string project_uuid = 2;
     */
    projectUuid?: string;

    /**
     * @generated from field: optional string project_job_uuid = 3;
     */
    projectJobUuid?: string;

    /**
     * @generated from field: double total_hours = 4;
     */
    totalHours: number;

    /**
     * @generated from field: google.protobuf.Timestamp date = 5;
     */
    date: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp start_time = 6;
     */
    startTime: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp end_time = 7;
     */
    endTime?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingTaskType task = 8;
     */
    task?: TimeTrackingTaskTypeValid;

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: string employee_uuid = 10;
     */
    employeeUuid: string;

    /**
     * @generated from field: uint32 total_seconds = 11 [deprecated = true];
     * @deprecated
     */
    totalSeconds: number;

    /**
     * @generated from field: bool in_progress = 12;
     */
    inProgress: boolean;

    /**
     * @generated from field: string project_survey_task_uuid = 13;
     */
    projectSurveyTaskUuid: string;

    /**
     * @generated from field: bool crew_leader = 14;
     */
    crewLeader: boolean;

    /**
     * @generated from field: map<string, string> attributes = 15;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingType type = 16;
     */
    type: TimeTrackingType;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingFlags flags = 17;
     */
    flags?: TimeTrackingFlagsValid;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingBilling billing = 18;
     */
    billing?: TimeTrackingBillingValid;
  };

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceCreateRequest.
 * Use `create(TimeTrackingServiceCreateRequestSchema)` to create a new message.
 */
export const TimeTrackingServiceCreateRequestSchema: GenMessage<
  TimeTrackingServiceCreateRequest,
  {
    jsonType: TimeTrackingServiceCreateRequestJson;
    validType: TimeTrackingServiceCreateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 7);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceCreateResponse
 */
export type TimeTrackingServiceCreateResponse =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceCreateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string project_uuid = 2;
     */
    projectUuid: string;

    /**
     * @generated from field: string project_job_uuid = 3;
     */
    projectJobUuid: string;

    /**
     * @generated from field: double total_hours = 4;
     */
    totalHours: number;

    /**
     * @generated from field: google.protobuf.Timestamp date = 5;
     */
    date?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp start_time = 6;
     */
    startTime?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp end_time = 7;
     */
    endTime?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingTaskType task = 8;
     */
    task?: TimeTrackingTaskType;

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: string employee_uuid = 10;
     */
    employeeUuid: string;

    /**
     * @generated from field: uint32 total_seconds = 11;
     */
    totalSeconds: number;

    /**
     * @generated from field: bool in_progress = 12;
     */
    inProgress: boolean;

    /**
     * @generated from field: string project_survey_task_uuid = 13;
     */
    projectSurveyTaskUuid: string;

    /**
     * @generated from field: bool crew_leader = 14;
     */
    crewLeader: boolean;

    /**
     * @generated from field: map<string, string> attributes = 15;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingType type = 16;
     */
    type: TimeTrackingType;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingFlags flags = 17;
     */
    flags?: TimeTrackingFlags;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingBilling billing = 18;
     */
    billing?: TimeTrackingBilling;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingServiceDenormalized denormalized = 28;
     */
    denormalized?: TimeTrackingServiceDenormalized;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceCreateResponse
 */
export type TimeTrackingServiceCreateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string project_uuid = 2;
   */
  projectUuid?: string;

  /**
   * @generated from field: string project_job_uuid = 3;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: double total_hours = 4;
   */
  totalHours?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: google.protobuf.Timestamp date = 5;
   */
  date?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 6;
   */
  startTime?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 7;
   */
  endTime?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingTaskType task = 8;
   */
  task?: TimeTrackingTaskTypeJson;

  /**
   * @generated from field: string notes = 9;
   */
  notes?: string;

  /**
   * @generated from field: string employee_uuid = 10;
   */
  employeeUuid?: string;

  /**
   * @generated from field: uint32 total_seconds = 11;
   */
  totalSeconds?: number;

  /**
   * @generated from field: bool in_progress = 12;
   */
  inProgress?: boolean;

  /**
   * @generated from field: string project_survey_task_uuid = 13;
   */
  projectSurveyTaskUuid?: string;

  /**
   * @generated from field: bool crew_leader = 14;
   */
  crewLeader?: boolean;

  /**
   * @generated from field: map<string, string> attributes = 15;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingType type = 16;
   */
  type?: TimeTrackingTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingFlags flags = 17;
   */
  flags?: TimeTrackingFlagsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingBilling billing = 18;
   */
  billing?: TimeTrackingBillingJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingServiceDenormalized denormalized = 28;
   */
  denormalized?: TimeTrackingServiceDenormalizedJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type TimeTrackingServiceCreateResponseValid =
  TimeTrackingServiceCreateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceCreateResponse.
 * Use `create(TimeTrackingServiceCreateResponseSchema)` to create a new message.
 */
export const TimeTrackingServiceCreateResponseSchema: GenMessage<
  TimeTrackingServiceCreateResponse,
  {
    jsonType: TimeTrackingServiceCreateResponseJson;
    validType: TimeTrackingServiceCreateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 8);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceUpdateRequest
 */
export type TimeTrackingServiceUpdateRequest =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: optional string project_uuid = 2;
     */
    projectUuid?: string;

    /**
     * @generated from field: optional string project_job_uuid = 3;
     */
    projectJobUuid?: string;

    /**
     * @generated from field: double total_hours = 4;
     */
    totalHours: number;

    /**
     * @generated from field: google.protobuf.Timestamp date = 5;
     */
    date?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp start_time = 6;
     */
    startTime?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp end_time = 7;
     */
    endTime?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingTaskType task = 8;
     */
    task?: TimeTrackingTaskType;

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: string employee_uuid = 10;
     */
    employeeUuid: string;

    /**
     * @generated from field: uint32 total_seconds = 11;
     */
    totalSeconds: number;

    /**
     * @generated from field: bool in_progress = 12;
     */
    inProgress: boolean;

    /**
     * @generated from field: string project_survey_task_uuid = 13;
     */
    projectSurveyTaskUuid: string;

    /**
     * @generated from field: bool crew_leader = 14;
     */
    crewLeader: boolean;

    /**
     * @generated from field: map<string, string> attributes = 15;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingType type = 16;
     */
    type: TimeTrackingType;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingFlags flags = 17;
     */
    flags?: TimeTrackingFlags;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingBilling billing = 18;
     */
    billing?: TimeTrackingBilling;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceUpdateRequest
 */
export type TimeTrackingServiceUpdateRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: optional string project_uuid = 2;
   */
  projectUuid?: string;

  /**
   * @generated from field: optional string project_job_uuid = 3;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: double total_hours = 4;
   */
  totalHours?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: google.protobuf.Timestamp date = 5;
   */
  date?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 6;
   */
  startTime?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 7;
   */
  endTime?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingTaskType task = 8;
   */
  task?: TimeTrackingTaskTypeJson;

  /**
   * @generated from field: string notes = 9;
   */
  notes?: string;

  /**
   * @generated from field: string employee_uuid = 10;
   */
  employeeUuid?: string;

  /**
   * @generated from field: uint32 total_seconds = 11;
   */
  totalSeconds?: number;

  /**
   * @generated from field: bool in_progress = 12;
   */
  inProgress?: boolean;

  /**
   * @generated from field: string project_survey_task_uuid = 13;
   */
  projectSurveyTaskUuid?: string;

  /**
   * @generated from field: bool crew_leader = 14;
   */
  crewLeader?: boolean;

  /**
   * @generated from field: map<string, string> attributes = 15;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingType type = 16;
   */
  type?: TimeTrackingTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingFlags flags = 17;
   */
  flags?: TimeTrackingFlagsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingBilling billing = 18;
   */
  billing?: TimeTrackingBillingJson;
};

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceUpdateRequest
 */
export type TimeTrackingServiceUpdateRequestValid =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: optional string project_uuid = 2;
     */
    projectUuid?: string;

    /**
     * @generated from field: optional string project_job_uuid = 3;
     */
    projectJobUuid?: string;

    /**
     * @generated from field: double total_hours = 4;
     */
    totalHours: number;

    /**
     * @generated from field: google.protobuf.Timestamp date = 5;
     */
    date: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp start_time = 6;
     */
    startTime: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp end_time = 7;
     */
    endTime?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingTaskType task = 8;
     */
    task?: TimeTrackingTaskTypeValid;

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: string employee_uuid = 10;
     */
    employeeUuid: string;

    /**
     * @generated from field: uint32 total_seconds = 11;
     */
    totalSeconds: number;

    /**
     * @generated from field: bool in_progress = 12;
     */
    inProgress: boolean;

    /**
     * @generated from field: string project_survey_task_uuid = 13;
     */
    projectSurveyTaskUuid: string;

    /**
     * @generated from field: bool crew_leader = 14;
     */
    crewLeader: boolean;

    /**
     * @generated from field: map<string, string> attributes = 15;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingType type = 16;
     */
    type: TimeTrackingType;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingFlags flags = 17;
     */
    flags?: TimeTrackingFlagsValid;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingBilling billing = 18;
     */
    billing?: TimeTrackingBillingValid;
  };

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceUpdateRequest.
 * Use `create(TimeTrackingServiceUpdateRequestSchema)` to create a new message.
 */
export const TimeTrackingServiceUpdateRequestSchema: GenMessage<
  TimeTrackingServiceUpdateRequest,
  {
    jsonType: TimeTrackingServiceUpdateRequestJson;
    validType: TimeTrackingServiceUpdateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 9);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceUpdateResponse
 */
export type TimeTrackingServiceUpdateResponse =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceUpdateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string project_uuid = 2;
     */
    projectUuid: string;

    /**
     * @generated from field: string project_job_uuid = 3;
     */
    projectJobUuid: string;

    /**
     * @generated from field: double total_hours = 4;
     */
    totalHours: number;

    /**
     * @generated from field: google.protobuf.Timestamp date = 5;
     */
    date?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp start_time = 6;
     */
    startTime?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp end_time = 7;
     */
    endTime?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingTaskType task = 8;
     */
    task?: TimeTrackingTaskType;

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: string employee_uuid = 10;
     */
    employeeUuid: string;

    /**
     * @generated from field: uint32 total_seconds = 11;
     */
    totalSeconds: number;

    /**
     * @generated from field: bool in_progress = 12;
     */
    inProgress: boolean;

    /**
     * @generated from field: string project_survey_task_uuid = 13;
     */
    projectSurveyTaskUuid: string;

    /**
     * @generated from field: bool crew_leader = 14;
     */
    crewLeader: boolean;

    /**
     * @generated from field: map<string, string> attributes = 15;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingType type = 16;
     */
    type: TimeTrackingType;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingFlags flags = 17;
     */
    flags?: TimeTrackingFlags;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingBilling billing = 18;
     */
    billing?: TimeTrackingBilling;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingServiceDenormalized denormalized = 28;
     */
    denormalized?: TimeTrackingServiceDenormalized;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceUpdateResponse
 */
export type TimeTrackingServiceUpdateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string project_uuid = 2;
   */
  projectUuid?: string;

  /**
   * @generated from field: string project_job_uuid = 3;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: double total_hours = 4;
   */
  totalHours?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: google.protobuf.Timestamp date = 5;
   */
  date?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 6;
   */
  startTime?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 7;
   */
  endTime?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingTaskType task = 8;
   */
  task?: TimeTrackingTaskTypeJson;

  /**
   * @generated from field: string notes = 9;
   */
  notes?: string;

  /**
   * @generated from field: string employee_uuid = 10;
   */
  employeeUuid?: string;

  /**
   * @generated from field: uint32 total_seconds = 11;
   */
  totalSeconds?: number;

  /**
   * @generated from field: bool in_progress = 12;
   */
  inProgress?: boolean;

  /**
   * @generated from field: string project_survey_task_uuid = 13;
   */
  projectSurveyTaskUuid?: string;

  /**
   * @generated from field: bool crew_leader = 14;
   */
  crewLeader?: boolean;

  /**
   * @generated from field: map<string, string> attributes = 15;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingType type = 16;
   */
  type?: TimeTrackingTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingFlags flags = 17;
   */
  flags?: TimeTrackingFlagsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingBilling billing = 18;
   */
  billing?: TimeTrackingBillingJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingServiceDenormalized denormalized = 28;
   */
  denormalized?: TimeTrackingServiceDenormalizedJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type TimeTrackingServiceUpdateResponseValid =
  TimeTrackingServiceUpdateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceUpdateResponse.
 * Use `create(TimeTrackingServiceUpdateResponseSchema)` to create a new message.
 */
export const TimeTrackingServiceUpdateResponseSchema: GenMessage<
  TimeTrackingServiceUpdateResponse,
  {
    jsonType: TimeTrackingServiceUpdateResponseJson;
    validType: TimeTrackingServiceUpdateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 10);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceGetRequest
 */
export type TimeTrackingServiceGetRequest =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceGetRequest
 */
export type TimeTrackingServiceGetRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceGetRequest
 */
export type TimeTrackingServiceGetRequestValid =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceGetRequest.
 * Use `create(TimeTrackingServiceGetRequestSchema)` to create a new message.
 */
export const TimeTrackingServiceGetRequestSchema: GenMessage<
  TimeTrackingServiceGetRequest,
  {
    jsonType: TimeTrackingServiceGetRequestJson;
    validType: TimeTrackingServiceGetRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 11);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceGetResponse
 */
export type TimeTrackingServiceGetResponse =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceGetResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string project_uuid = 2;
     */
    projectUuid: string;

    /**
     * @generated from field: string project_job_uuid = 3;
     */
    projectJobUuid: string;

    /**
     * @generated from field: double total_hours = 4;
     */
    totalHours: number;

    /**
     * @generated from field: google.protobuf.Timestamp date = 5;
     */
    date?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp start_time = 6;
     */
    startTime?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp end_time = 7;
     */
    endTime?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingTaskType task = 8;
     */
    task?: TimeTrackingTaskType;

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: string employee_uuid = 10;
     */
    employeeUuid: string;

    /**
     * @generated from field: uint32 total_seconds = 11;
     */
    totalSeconds: number;

    /**
     * @generated from field: bool in_progress = 12;
     */
    inProgress: boolean;

    /**
     * @generated from field: string project_survey_task_uuid = 13;
     */
    projectSurveyTaskUuid: string;

    /**
     * @generated from field: bool crew_leader = 14;
     */
    crewLeader: boolean;

    /**
     * @generated from field: map<string, string> attributes = 15;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingType type = 16;
     */
    type: TimeTrackingType;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingFlags flags = 17;
     */
    flags?: TimeTrackingFlags;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingBilling billing = 18;
     */
    billing?: TimeTrackingBilling;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingServiceDenormalized denormalized = 28;
     */
    denormalized?: TimeTrackingServiceDenormalized;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceGetResponse
 */
export type TimeTrackingServiceGetResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string project_uuid = 2;
   */
  projectUuid?: string;

  /**
   * @generated from field: string project_job_uuid = 3;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: double total_hours = 4;
   */
  totalHours?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: google.protobuf.Timestamp date = 5;
   */
  date?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 6;
   */
  startTime?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 7;
   */
  endTime?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingTaskType task = 8;
   */
  task?: TimeTrackingTaskTypeJson;

  /**
   * @generated from field: string notes = 9;
   */
  notes?: string;

  /**
   * @generated from field: string employee_uuid = 10;
   */
  employeeUuid?: string;

  /**
   * @generated from field: uint32 total_seconds = 11;
   */
  totalSeconds?: number;

  /**
   * @generated from field: bool in_progress = 12;
   */
  inProgress?: boolean;

  /**
   * @generated from field: string project_survey_task_uuid = 13;
   */
  projectSurveyTaskUuid?: string;

  /**
   * @generated from field: bool crew_leader = 14;
   */
  crewLeader?: boolean;

  /**
   * @generated from field: map<string, string> attributes = 15;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingType type = 16;
   */
  type?: TimeTrackingTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingFlags flags = 17;
   */
  flags?: TimeTrackingFlagsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingBilling billing = 18;
   */
  billing?: TimeTrackingBillingJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingServiceDenormalized denormalized = 28;
   */
  denormalized?: TimeTrackingServiceDenormalizedJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type TimeTrackingServiceGetResponseValid =
  TimeTrackingServiceGetResponse;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceGetResponse.
 * Use `create(TimeTrackingServiceGetResponseSchema)` to create a new message.
 */
export const TimeTrackingServiceGetResponseSchema: GenMessage<
  TimeTrackingServiceGetResponse,
  {
    jsonType: TimeTrackingServiceGetResponseJson;
    validType: TimeTrackingServiceGetResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 12);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceInProgressRequest
 */
export type TimeTrackingServiceInProgressRequest =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceInProgressRequest'> & {
    /**
     * @generated from field: string employee_uuid = 1;
     */
    employeeUuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceInProgressRequest
 */
export type TimeTrackingServiceInProgressRequestJson = {
  /**
   * @generated from field: string employee_uuid = 1;
   */
  employeeUuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceInProgressRequest
 */
export type TimeTrackingServiceInProgressRequestValid =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceInProgressRequest'> & {
    /**
     * @generated from field: string employee_uuid = 1;
     */
    employeeUuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceInProgressRequest.
 * Use `create(TimeTrackingServiceInProgressRequestSchema)` to create a new message.
 */
export const TimeTrackingServiceInProgressRequestSchema: GenMessage<
  TimeTrackingServiceInProgressRequest,
  {
    jsonType: TimeTrackingServiceInProgressRequestJson;
    validType: TimeTrackingServiceInProgressRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 13);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceInProgressResponse
 */
export type TimeTrackingServiceInProgressResponse =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceInProgressResponse'> & {
    /**
     * @generated from field: optional vmspdb.api.proto.v1.TimeTrackingServiceGetResponse record = 1;
     */
    record?: TimeTrackingServiceGetResponse;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceInProgressResponse
 */
export type TimeTrackingServiceInProgressResponseJson = {
  /**
   * @generated from field: optional vmspdb.api.proto.v1.TimeTrackingServiceGetResponse record = 1;
   */
  record?: TimeTrackingServiceGetResponseJson;
};

export type TimeTrackingServiceInProgressResponseValid =
  TimeTrackingServiceInProgressResponse;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceInProgressResponse.
 * Use `create(TimeTrackingServiceInProgressResponseSchema)` to create a new message.
 */
export const TimeTrackingServiceInProgressResponseSchema: GenMessage<
  TimeTrackingServiceInProgressResponse,
  {
    jsonType: TimeTrackingServiceInProgressResponseJson;
    validType: TimeTrackingServiceInProgressResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 14);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceDeleteRequest
 */
export type TimeTrackingServiceDeleteRequest =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceDeleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceDeleteRequest
 */
export type TimeTrackingServiceDeleteRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceDeleteRequest
 */
export type TimeTrackingServiceDeleteRequestValid =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceDeleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceDeleteRequest.
 * Use `create(TimeTrackingServiceDeleteRequestSchema)` to create a new message.
 */
export const TimeTrackingServiceDeleteRequestSchema: GenMessage<
  TimeTrackingServiceDeleteRequest,
  {
    jsonType: TimeTrackingServiceDeleteRequestJson;
    validType: TimeTrackingServiceDeleteRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 15);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceDeleteResponse
 */
export type TimeTrackingServiceDeleteResponse =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceDeleteResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceDeleteResponse
 */
export type TimeTrackingServiceDeleteResponseJson = {};

export type TimeTrackingServiceDeleteResponseValid =
  TimeTrackingServiceDeleteResponse;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceDeleteResponse.
 * Use `create(TimeTrackingServiceDeleteResponseSchema)` to create a new message.
 */
export const TimeTrackingServiceDeleteResponseSchema: GenMessage<
  TimeTrackingServiceDeleteResponse,
  {
    jsonType: TimeTrackingServiceDeleteResponseJson;
    validType: TimeTrackingServiceDeleteResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 16);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingRecord
 */
export type TimeTrackingRecord =
  Message<'vmspdb.api.proto.v1.TimeTrackingRecord'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: google.protobuf.Timestamp start_time = 2;
     */
    startTime?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp end_time = 3;
     */
    endTime?: Timestamp;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingRecord
 */
export type TimeTrackingRecordJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: TimestampJson;
};

export type TimeTrackingRecordValid = TimeTrackingRecord;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingRecord.
 * Use `create(TimeTrackingRecordSchema)` to create a new message.
 */
export const TimeTrackingRecordSchema: GenMessage<
  TimeTrackingRecord,
  { jsonType: TimeTrackingRecordJson; validType: TimeTrackingRecordValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 17);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceListRequest
 */
export type TimeTrackingServiceListRequest =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceListRequest'> & {
    /**
     * @generated from field: string filter = 1;
     */
    filter: string;

    /**
     * @generated from field: uint32 page_index = 2;
     */
    pageIndex: number;

    /**
     * @generated from field: uint32 page_size = 3;
     */
    pageSize: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
     */
    sortDirection: SortDirection;

    /**
     * @generated from field: string sort_field = 5 [deprecated = true];
     * @deprecated
     */
    sortField: string;

    /**
     * @generated from field: string employee = 6 [deprecated = true];
     * @deprecated
     */
    employee: string;

    /**
     * @generated from field: string project = 7 [deprecated = true];
     * @deprecated
     */
    project: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingCrewFilter crew_filter = 8;
     */
    crewFilter: TimeTrackingCrewFilter;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingEmployeePaidFilter paid_filter = 9;
     */
    paidFilter: TimeTrackingEmployeePaidFilter;

    /**
     * @generated from field: vmspdb.api.proto.v1.DateRange date_range = 10;
     */
    dateRange?: DateRange;

    /**
     * @generated from field: optional string project_uuid = 11;
     */
    projectUuid?: string;

    /**
     * @generated from field: optional string employee_uuid = 12;
     */
    employeeUuid?: string;

    /**
     * @generated from field: optional bool in_progress = 13;
     */
    inProgress?: boolean;

    /**
     * @generated from field: vmspdb.api.proto.v1.TimeTrackingSort sort = 14;
     */
    sort: TimeTrackingSort;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceListRequest
 */
export type TimeTrackingServiceListRequestJson = {
  /**
   * @generated from field: string filter = 1;
   */
  filter?: string;

  /**
   * @generated from field: uint32 page_index = 2;
   */
  pageIndex?: number;

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize?: number;

  /**
   * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
   */
  sortDirection?: SortDirectionJson;

  /**
   * @generated from field: string sort_field = 5 [deprecated = true];
   * @deprecated
   */
  sortField?: string;

  /**
   * @generated from field: string employee = 6 [deprecated = true];
   * @deprecated
   */
  employee?: string;

  /**
   * @generated from field: string project = 7 [deprecated = true];
   * @deprecated
   */
  project?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingCrewFilter crew_filter = 8;
   */
  crewFilter?: TimeTrackingCrewFilterJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingEmployeePaidFilter paid_filter = 9;
   */
  paidFilter?: TimeTrackingEmployeePaidFilterJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.DateRange date_range = 10;
   */
  dateRange?: DateRangeJson;

  /**
   * @generated from field: optional string project_uuid = 11;
   */
  projectUuid?: string;

  /**
   * @generated from field: optional string employee_uuid = 12;
   */
  employeeUuid?: string;

  /**
   * @generated from field: optional bool in_progress = 13;
   */
  inProgress?: boolean;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingSort sort = 14;
   */
  sort?: TimeTrackingSortJson;
};

export type TimeTrackingServiceListRequestValid =
  TimeTrackingServiceListRequest;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceListRequest.
 * Use `create(TimeTrackingServiceListRequestSchema)` to create a new message.
 */
export const TimeTrackingServiceListRequestSchema: GenMessage<
  TimeTrackingServiceListRequest,
  {
    jsonType: TimeTrackingServiceListRequestJson;
    validType: TimeTrackingServiceListRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 18);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceListResponse
 */
export type TimeTrackingServiceListResponse =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceListResponse'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.TimeTrackingServiceCreateResponse items = 1;
     */
    items: TimeTrackingServiceCreateResponse[];

    /**
     * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
     */
    pagination?: Pagination;

    /**
     * @generated from field: bool degraded = 3;
     */
    degraded: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceListResponse
 */
export type TimeTrackingServiceListResponseJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.TimeTrackingServiceCreateResponse items = 1;
   */
  items?: TimeTrackingServiceCreateResponseJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
   */
  pagination?: PaginationJson;

  /**
   * @generated from field: bool degraded = 3;
   */
  degraded?: boolean;
};

export type TimeTrackingServiceListResponseValid =
  TimeTrackingServiceListResponse;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceListResponse.
 * Use `create(TimeTrackingServiceListResponseSchema)` to create a new message.
 */
export const TimeTrackingServiceListResponseSchema: GenMessage<
  TimeTrackingServiceListResponse,
  {
    jsonType: TimeTrackingServiceListResponseJson;
    validType: TimeTrackingServiceListResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 19);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceMarkPaidRequest
 */
export type TimeTrackingServiceMarkPaidRequest =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceMarkPaidRequest'> & {
    /**
     * @generated from field: repeated string uuids = 1;
     */
    uuids: string[];
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceMarkPaidRequest
 */
export type TimeTrackingServiceMarkPaidRequestJson = {
  /**
   * @generated from field: repeated string uuids = 1;
   */
  uuids?: string[];
};

export type TimeTrackingServiceMarkPaidRequestValid =
  TimeTrackingServiceMarkPaidRequest;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceMarkPaidRequest.
 * Use `create(TimeTrackingServiceMarkPaidRequestSchema)` to create a new message.
 */
export const TimeTrackingServiceMarkPaidRequestSchema: GenMessage<
  TimeTrackingServiceMarkPaidRequest,
  {
    jsonType: TimeTrackingServiceMarkPaidRequestJson;
    validType: TimeTrackingServiceMarkPaidRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 20);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceMarkPaidResponse
 */
export type TimeTrackingServiceMarkPaidResponse =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceMarkPaidResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceMarkPaidResponse
 */
export type TimeTrackingServiceMarkPaidResponseJson = {};

export type TimeTrackingServiceMarkPaidResponseValid =
  TimeTrackingServiceMarkPaidResponse;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceMarkPaidResponse.
 * Use `create(TimeTrackingServiceMarkPaidResponseSchema)` to create a new message.
 */
export const TimeTrackingServiceMarkPaidResponseSchema: GenMessage<
  TimeTrackingServiceMarkPaidResponse,
  {
    jsonType: TimeTrackingServiceMarkPaidResponseJson;
    validType: TimeTrackingServiceMarkPaidResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 21);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceMarkCompleteRequest
 */
export type TimeTrackingServiceMarkCompleteRequest =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceMarkCompleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceMarkCompleteRequest
 */
export type TimeTrackingServiceMarkCompleteRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceMarkCompleteRequest
 */
export type TimeTrackingServiceMarkCompleteRequestValid =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceMarkCompleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceMarkCompleteRequest.
 * Use `create(TimeTrackingServiceMarkCompleteRequestSchema)` to create a new message.
 */
export const TimeTrackingServiceMarkCompleteRequestSchema: GenMessage<
  TimeTrackingServiceMarkCompleteRequest,
  {
    jsonType: TimeTrackingServiceMarkCompleteRequestJson;
    validType: TimeTrackingServiceMarkCompleteRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 22);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceMarkCompleteResponse
 */
export type TimeTrackingServiceMarkCompleteResponse =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceMarkCompleteResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceMarkCompleteResponse
 */
export type TimeTrackingServiceMarkCompleteResponseJson = {};

export type TimeTrackingServiceMarkCompleteResponseValid =
  TimeTrackingServiceMarkCompleteResponse;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceMarkCompleteResponse.
 * Use `create(TimeTrackingServiceMarkCompleteResponseSchema)` to create a new message.
 */
export const TimeTrackingServiceMarkCompleteResponseSchema: GenMessage<
  TimeTrackingServiceMarkCompleteResponse,
  {
    jsonType: TimeTrackingServiceMarkCompleteResponseJson;
    validType: TimeTrackingServiceMarkCompleteResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 23);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTimeTrackingOption
 */
export type ProjectSurveyTimeTrackingOption =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTimeTrackingOption'> & {
    /**
     * @generated from field: string label = 1;
     */
    label: string;

    /**
     * @generated from field: string option_value = 2;
     */
    optionValue: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTimeTrackingOption
 */
export type ProjectSurveyTimeTrackingOptionJson = {
  /**
   * @generated from field: string label = 1;
   */
  label?: string;

  /**
   * @generated from field: string option_value = 2;
   */
  optionValue?: string;
};

export type ProjectSurveyTimeTrackingOptionValid =
  ProjectSurveyTimeTrackingOption;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTimeTrackingOption.
 * Use `create(ProjectSurveyTimeTrackingOptionSchema)` to create a new message.
 */
export const ProjectSurveyTimeTrackingOptionSchema: GenMessage<
  ProjectSurveyTimeTrackingOption,
  {
    jsonType: ProjectSurveyTimeTrackingOptionJson;
    validType: ProjectSurveyTimeTrackingOptionValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 24);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceAllowedSurveyOptionsRequest
 */
export type TimeTrackingServiceAllowedSurveyOptionsRequest =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceAllowedSurveyOptionsRequest'> & {
    /**
     * @generated from field: string project_uuid = 1;
     */
    projectUuid: string;

    /**
     * @generated from field: optional string time_tracking_uuid = 2 [deprecated = true];
     * @deprecated
     */
    timeTrackingUuid?: string;

    /**
     * @generated from field: bool show_all = 3;
     */
    showAll: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceAllowedSurveyOptionsRequest
 */
export type TimeTrackingServiceAllowedSurveyOptionsRequestJson = {
  /**
   * @generated from field: string project_uuid = 1;
   */
  projectUuid?: string;

  /**
   * @generated from field: optional string time_tracking_uuid = 2 [deprecated = true];
   * @deprecated
   */
  timeTrackingUuid?: string;

  /**
   * @generated from field: bool show_all = 3;
   */
  showAll?: boolean;
};

export type TimeTrackingServiceAllowedSurveyOptionsRequestValid =
  TimeTrackingServiceAllowedSurveyOptionsRequest;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceAllowedSurveyOptionsRequest.
 * Use `create(TimeTrackingServiceAllowedSurveyOptionsRequestSchema)` to create a new message.
 */
export const TimeTrackingServiceAllowedSurveyOptionsRequestSchema: GenMessage<
  TimeTrackingServiceAllowedSurveyOptionsRequest,
  {
    jsonType: TimeTrackingServiceAllowedSurveyOptionsRequestJson;
    validType: TimeTrackingServiceAllowedSurveyOptionsRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 25);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceAllowedSurveyOptionsResponse
 */
export type TimeTrackingServiceAllowedSurveyOptionsResponse =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceAllowedSurveyOptionsResponse'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTimeTrackingOption options = 1;
     */
    options: ProjectSurveyTimeTrackingOption[];
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceAllowedSurveyOptionsResponse
 */
export type TimeTrackingServiceAllowedSurveyOptionsResponseJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTimeTrackingOption options = 1;
   */
  options?: ProjectSurveyTimeTrackingOptionJson[];
};

export type TimeTrackingServiceAllowedSurveyOptionsResponseValid =
  TimeTrackingServiceAllowedSurveyOptionsResponse;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceAllowedSurveyOptionsResponse.
 * Use `create(TimeTrackingServiceAllowedSurveyOptionsResponseSchema)` to create a new message.
 */
export const TimeTrackingServiceAllowedSurveyOptionsResponseSchema: GenMessage<
  TimeTrackingServiceAllowedSurveyOptionsResponse,
  {
    jsonType: TimeTrackingServiceAllowedSurveyOptionsResponseJson;
    validType: TimeTrackingServiceAllowedSurveyOptionsResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 26);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceHeading
 */
export type TimeTrackingServiceHeading =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceHeading'> & {
    /**
     * @generated from field: double total_hours = 1;
     */
    totalHours: number;

    /**
     * @generated from field: double total_billed_hours = 2;
     */
    totalBilledHours: number;

    /**
     * @generated from field: uint32 total_seconds = 3;
     */
    totalSeconds: number;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceHeading
 */
export type TimeTrackingServiceHeadingJson = {
  /**
   * @generated from field: double total_hours = 1;
   */
  totalHours?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: double total_billed_hours = 2;
   */
  totalBilledHours?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: uint32 total_seconds = 3;
   */
  totalSeconds?: number;
};

export type TimeTrackingServiceHeadingValid = TimeTrackingServiceHeading;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceHeading.
 * Use `create(TimeTrackingServiceHeadingSchema)` to create a new message.
 */
export const TimeTrackingServiceHeadingSchema: GenMessage<
  TimeTrackingServiceHeading,
  {
    jsonType: TimeTrackingServiceHeadingJson;
    validType: TimeTrackingServiceHeadingValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 27);

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceRow
 */
export type TimeTrackingServiceRow =
  Message<'vmspdb.api.proto.v1.TimeTrackingServiceRow'> & {
    /**
     * @generated from oneof vmspdb.api.proto.v1.TimeTrackingServiceRow.type
     */
    type:
      | {
          /**
           * @generated from field: vmspdb.api.proto.v1.TimeTrackingServiceHeading heading = 1;
           */
          value: TimeTrackingServiceHeading;
          case: 'heading';
        }
      | {
          /**
           * @generated from field: vmspdb.api.proto.v1.TimeTrackingServiceCreateResponse record = 2;
           */
          value: TimeTrackingServiceCreateResponse;
          case: 'record';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * @generated from message vmspdb.api.proto.v1.TimeTrackingServiceRow
 */
export type TimeTrackingServiceRowJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingServiceHeading heading = 1;
   */
  heading?: TimeTrackingServiceHeadingJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TimeTrackingServiceCreateResponse record = 2;
   */
  record?: TimeTrackingServiceCreateResponseJson;
};

export type TimeTrackingServiceRowValid = TimeTrackingServiceRow;

/**
 * Describes the message vmspdb.api.proto.v1.TimeTrackingServiceRow.
 * Use `create(TimeTrackingServiceRowSchema)` to create a new message.
 */
export const TimeTrackingServiceRowSchema: GenMessage<
  TimeTrackingServiceRow,
  {
    jsonType: TimeTrackingServiceRowJson;
    validType: TimeTrackingServiceRowValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_time_tracking, 28);

/**
 * @generated from enum vmspdb.api.proto.v1.TimeTrackingType
 */
export enum TimeTrackingType {
  /**
   * @generated from enum value: TIME_TRACKING_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_TRACKING_TYPE_EMPLOYEE = 1;
   */
  EMPLOYEE = 1,

  /**
   * @generated from enum value: TIME_TRACKING_TYPE_CREW_LEADER = 2;
   */
  CREW_LEADER = 2,

  /**
   * @generated from enum value: TIME_TRACKING_TYPE_OFFICE = 3;
   */
  OFFICE = 3,
}

/**
 * @generated from enum vmspdb.api.proto.v1.TimeTrackingType
 */
export type TimeTrackingTypeJson =
  | 'TIME_TRACKING_TYPE_UNSPECIFIED'
  | 'TIME_TRACKING_TYPE_EMPLOYEE'
  | 'TIME_TRACKING_TYPE_CREW_LEADER'
  | 'TIME_TRACKING_TYPE_OFFICE';

/**
 * Describes the enum vmspdb.api.proto.v1.TimeTrackingType.
 */
export const TimeTrackingTypeSchema: GenEnum<
  TimeTrackingType,
  TimeTrackingTypeJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_time_tracking, 0);

/**
 * @generated from enum vmspdb.api.proto.v1.TimeTrackingDefaultType
 */
export enum TimeTrackingDefaultType {
  /**
   * @generated from enum value: TIME_TRACKING_DEFAULT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_TRACKING_DEFAULT_TYPE_PLOT_PLAN = 1;
   */
  PLOT_PLAN = 1,

  /**
   * @generated from enum value: TIME_TRACKING_DEFAULT_TYPE_EXISTING_CONDITIONS = 2;
   */
  EXISTING_CONDITIONS = 2,

  /**
   * @generated from enum value: TIME_TRACKING_DEFAULT_TYPE_GRADING_AND_DRAINAGE = 3;
   */
  GRADING_AND_DRAINAGE = 3,

  /**
   * @generated from enum value: TIME_TRACKING_DEFAULT_TYPE_SANITARY_SEWER = 4;
   */
  SANITARY_SEWER = 4,

  /**
   * @generated from enum value: TIME_TRACKING_DEFAULT_TYPE_LANDSCAPING = 5;
   */
  LANDSCAPING = 5,

  /**
   * @generated from enum value: TIME_TRACKING_DEFAULT_TYPE_WATERLINE = 6;
   */
  WATERLINE = 6,
}

/**
 * @generated from enum vmspdb.api.proto.v1.TimeTrackingDefaultType
 */
export type TimeTrackingDefaultTypeJson =
  | 'TIME_TRACKING_DEFAULT_TYPE_UNSPECIFIED'
  | 'TIME_TRACKING_DEFAULT_TYPE_PLOT_PLAN'
  | 'TIME_TRACKING_DEFAULT_TYPE_EXISTING_CONDITIONS'
  | 'TIME_TRACKING_DEFAULT_TYPE_GRADING_AND_DRAINAGE'
  | 'TIME_TRACKING_DEFAULT_TYPE_SANITARY_SEWER'
  | 'TIME_TRACKING_DEFAULT_TYPE_LANDSCAPING'
  | 'TIME_TRACKING_DEFAULT_TYPE_WATERLINE';

/**
 * Describes the enum vmspdb.api.proto.v1.TimeTrackingDefaultType.
 */
export const TimeTrackingDefaultTypeSchema: GenEnum<
  TimeTrackingDefaultType,
  TimeTrackingDefaultTypeJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_time_tracking, 1);

/**
 * @generated from enum vmspdb.api.proto.v1.TimeTrackingCrewFilter
 */
export enum TimeTrackingCrewFilter {
  /**
   * @generated from enum value: TIME_TRACKING_CREW_FILTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_TRACKING_CREW_FILTER_CREW_ONLY = 1;
   */
  CREW_ONLY = 1,

  /**
   * @generated from enum value: TIME_TRACKING_CREW_FILTER_INDIVIDUAL = 2;
   */
  INDIVIDUAL = 2,
}

/**
 * @generated from enum vmspdb.api.proto.v1.TimeTrackingCrewFilter
 */
export type TimeTrackingCrewFilterJson =
  | 'TIME_TRACKING_CREW_FILTER_UNSPECIFIED'
  | 'TIME_TRACKING_CREW_FILTER_CREW_ONLY'
  | 'TIME_TRACKING_CREW_FILTER_INDIVIDUAL';

/**
 * Describes the enum vmspdb.api.proto.v1.TimeTrackingCrewFilter.
 */
export const TimeTrackingCrewFilterSchema: GenEnum<
  TimeTrackingCrewFilter,
  TimeTrackingCrewFilterJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_time_tracking, 2);

/**
 * @generated from enum vmspdb.api.proto.v1.TimeTrackingEmployeePaidFilter
 */
export enum TimeTrackingEmployeePaidFilter {
  /**
   * @generated from enum value: TIME_TRACKING_EMPLOYEE_PAID_FILTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_TRACKING_EMPLOYEE_PAID_FILTER_PAID = 1;
   */
  PAID = 1,

  /**
   * @generated from enum value: TIME_TRACKING_EMPLOYEE_PAID_FILTER_UNPAID = 2;
   */
  UNPAID = 2,
}

/**
 * @generated from enum vmspdb.api.proto.v1.TimeTrackingEmployeePaidFilter
 */
export type TimeTrackingEmployeePaidFilterJson =
  | 'TIME_TRACKING_EMPLOYEE_PAID_FILTER_UNSPECIFIED'
  | 'TIME_TRACKING_EMPLOYEE_PAID_FILTER_PAID'
  | 'TIME_TRACKING_EMPLOYEE_PAID_FILTER_UNPAID';

/**
 * Describes the enum vmspdb.api.proto.v1.TimeTrackingEmployeePaidFilter.
 */
export const TimeTrackingEmployeePaidFilterSchema: GenEnum<
  TimeTrackingEmployeePaidFilter,
  TimeTrackingEmployeePaidFilterJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_time_tracking, 3);

/**
 * @generated from enum vmspdb.api.proto.v1.TimeTrackingSort
 */
export enum TimeTrackingSort {
  /**
   * @generated from enum value: TIME_TRACKING_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_DATE = 1;
   */
  DATE = 1,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_EMPLOYEE_NAME = 2;
   */
  EMPLOYEE_NAME = 2,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_PROJECT_NAME = 3;
   */
  PROJECT_NAME = 3,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_JOB_NAME = 4;
   */
  JOB_NAME = 4,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_CLIENT = 5;
   */
  CLIENT = 5,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_REQUESTOR = 6;
   */
  REQUESTOR = 6,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_SURVEYING_TASK = 7;
   */
  SURVEYING_TASK = 7,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_TASK_DESCRIPTION = 8;
   */
  TASK_DESCRIPTION = 8,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_SURVEYING_TASK_NOTES = 9;
   */
  SURVEYING_TASK_NOTES = 9,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_NOTES = 10;
   */
  NOTES = 10,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_START_TIME = 11;
   */
  START_TIME = 11,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_END_TIME = 12;
   */
  END_TIME = 12,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_TOTAL_HOURS = 13;
   */
  TOTAL_HOURS = 13,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_TOTAL_BILLED_HOURS = 14;
   */
  TOTAL_BILLED_HOURS = 14,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_BILLED_TO = 15;
   */
  BILLED_TO = 15,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_EMPLOYEE_PAID = 16;
   */
  EMPLOYEE_PAID = 16,

  /**
   * @generated from enum value: TIME_TRACKING_SORT_JOB_NUMBER = 17;
   */
  JOB_NUMBER = 17,
}

/**
 * @generated from enum vmspdb.api.proto.v1.TimeTrackingSort
 */
export type TimeTrackingSortJson =
  | 'TIME_TRACKING_SORT_UNSPECIFIED'
  | 'TIME_TRACKING_SORT_DATE'
  | 'TIME_TRACKING_SORT_EMPLOYEE_NAME'
  | 'TIME_TRACKING_SORT_PROJECT_NAME'
  | 'TIME_TRACKING_SORT_JOB_NAME'
  | 'TIME_TRACKING_SORT_CLIENT'
  | 'TIME_TRACKING_SORT_REQUESTOR'
  | 'TIME_TRACKING_SORT_SURVEYING_TASK'
  | 'TIME_TRACKING_SORT_TASK_DESCRIPTION'
  | 'TIME_TRACKING_SORT_SURVEYING_TASK_NOTES'
  | 'TIME_TRACKING_SORT_NOTES'
  | 'TIME_TRACKING_SORT_START_TIME'
  | 'TIME_TRACKING_SORT_END_TIME'
  | 'TIME_TRACKING_SORT_TOTAL_HOURS'
  | 'TIME_TRACKING_SORT_TOTAL_BILLED_HOURS'
  | 'TIME_TRACKING_SORT_BILLED_TO'
  | 'TIME_TRACKING_SORT_EMPLOYEE_PAID'
  | 'TIME_TRACKING_SORT_JOB_NUMBER';

/**
 * Describes the enum vmspdb.api.proto.v1.TimeTrackingSort.
 */
export const TimeTrackingSortSchema: GenEnum<
  TimeTrackingSort,
  TimeTrackingSortJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_time_tracking, 4);

/**
 * @generated from service vmspdb.api.proto.v1.TimeTrackingService
 */
export const TimeTrackingService: GenService<{
  /**
   * @generated from rpc vmspdb.api.proto.v1.TimeTrackingService.Create
   */
  create: {
    methodKind: 'unary';
    input: typeof TimeTrackingServiceCreateRequestSchema;
    output: typeof TimeTrackingServiceCreateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.TimeTrackingService.Get
   */
  get: {
    methodKind: 'unary';
    input: typeof TimeTrackingServiceGetRequestSchema;
    output: typeof TimeTrackingServiceGetResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.TimeTrackingService.InProgress
   */
  inProgress: {
    methodKind: 'unary';
    input: typeof TimeTrackingServiceInProgressRequestSchema;
    output: typeof TimeTrackingServiceInProgressResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.TimeTrackingService.Update
   */
  update: {
    methodKind: 'unary';
    input: typeof TimeTrackingServiceUpdateRequestSchema;
    output: typeof TimeTrackingServiceUpdateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.TimeTrackingService.Delete
   */
  delete: {
    methodKind: 'unary';
    input: typeof TimeTrackingServiceDeleteRequestSchema;
    output: typeof TimeTrackingServiceDeleteResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.TimeTrackingService.List
   */
  list: {
    methodKind: 'unary';
    input: typeof TimeTrackingServiceListRequestSchema;
    output: typeof TimeTrackingServiceListResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.TimeTrackingService.MarkPaid
   */
  markPaid: {
    methodKind: 'unary';
    input: typeof TimeTrackingServiceMarkPaidRequestSchema;
    output: typeof TimeTrackingServiceMarkPaidResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.TimeTrackingService.MarkComplete
   */
  markComplete: {
    methodKind: 'unary';
    input: typeof TimeTrackingServiceMarkCompleteRequestSchema;
    output: typeof TimeTrackingServiceMarkCompleteResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.TimeTrackingService.AllowedSurveyOptions
   */
  allowedSurveyOptions: {
    methodKind: 'unary';
    input: typeof TimeTrackingServiceAllowedSurveyOptionsRequestSchema;
    output: typeof TimeTrackingServiceAllowedSurveyOptionsResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_proto_v1_time_tracking, 0);
